import React from 'react'
import { makeStyles } from '@mui/styles'
import { Grid, ListItem, ListItemText, Typography } from '@mui/material'

const useStyles = makeStyles(({ spacing, typography }) => ({
  searchSuggestionsTitle: {
    cursor: 'default',
    padding: spacing(1, 2),
    '& span': {
      ...typography.body.s,
      fontWeight: typography.fontWeightBold,
      color: '#212121'
    }
  },
  suggestedContentItem: {
    padding: spacing(1, 2),
    cursor: 'pointer',
    '&:hover, &:focus': {
      background: '#F2F2F2',
      outline: 'none'
    }
  },
  itemText: {
    color: '#212121'
  }
}))

export const PaidConsumerRecommendedKeywords = ({ suggestions, onSuggestionSelect }) => {
  const classes = useStyles()
  const testAttr = 'paid-consumer-recommended-keywords'

  return (
    <>
      <ListItem divider className={classes.searchSuggestionsTitle}>
        <ListItemText
          primaryTypographyProps={{ 'data-test': `${testAttr}-title` }}
        >
          Recommended Keywords
        </ListItemText>
      </ListItem>
      {suggestions.map((value, idx) => (
        <ListItem
          role='button'
          tabIndex={0}
          aria-label={`Recommended keyword: ${value}`}
          component='li'
          onClick={() => onSuggestionSelect(value, 'search-suggestion', idx)}
          divider={idx < suggestions.length - 1}
          key={idx}
          className={classes.suggestedContentItem}
          data-test={`${testAttr}-item-${idx}`}
        >
          <ListItemText disableTypography>
            <Grid
              container
              wrap='nowrap'
              alignItems='center'
              justifyContent='space-between'
              spacing={2}
            >
              <Grid item>
                <Typography
                  variant='body2'
                  className={classes.itemText}
                >
                  {value}
                </Typography>
              </Grid>
            </Grid>
          </ListItemText>
        </ListItem>
      ))}
    </>
  )
}
